export function adaptEngagementDetails(data) {
  var _data$title, _data$startTime, _data$endTime, _data$callSource;
  const participants = data.participants.map(p => ({
    name: p.name,
    isOrganizer: p.isHost
  }));
  return {
    title: (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : '',
    startTime: (_data$startTime = data.startTime) !== null && _data$startTime !== void 0 ? _data$startTime : null,
    endTime: (_data$endTime = data.endTime) !== null && _data$endTime !== void 0 ? _data$endTime : null,
    callSource: (_data$callSource = data.callSource) !== null && _data$callSource !== void 0 ? _data$callSource : null,
    participants
  };
}
export function adaptRecording(data) {
  if (data.presignedVideoUrl) {
    return {
      presignedUrl: data.presignedVideoUrl,
      mediaType: 'VIDEO',
      durationSeconds: 0
    };
  }
  if (data.presignedAudioUrl) {
    return {
      presignedUrl: data.presignedAudioUrl,
      mediaType: 'AUDIO',
      durationSeconds: 0
    };
  }
  return undefined;
}

// handles plain numeric strings and ISO 8601 durations from Java's Duration type
function parseDuration(value) {
  if (!value) {
    return 0;
  }
  const num = Number(value);
  if (!isNaN(num)) {
    return num;
  }
  const match = value.match(/^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?$/);
  if (match) {
    const hours = parseFloat(match[1] || '0');
    const minutes = parseFloat(match[2] || '0');
    const seconds = parseFloat(match[3] || '0');
    return hours * 3600 + minutes * 60 + seconds;
  }
  return 0;
}
export function adaptTranscript(data) {
  var _data$transcript$tran, _data$transcript;
  const rawUtterances = (_data$transcript$tran = (_data$transcript = data.transcript) === null || _data$transcript === void 0 ? void 0 : _data$transcript.transcriptUtterances) !== null && _data$transcript$tran !== void 0 ? _data$transcript$tran : [];
  const speakerMap = new Map();
  const utterances = rawUtterances.map((u, index) => {
    var _u$speakerMaybe$name, _u$speakerMaybe;
    const speakerName = (_u$speakerMaybe$name = (_u$speakerMaybe = u.speakerMaybe) === null || _u$speakerMaybe === void 0 ? void 0 : _u$speakerMaybe.name) !== null && _u$speakerMaybe$name !== void 0 ? _u$speakerMaybe$name : 'Unknown';
    if (!speakerMap.has(speakerName)) {
      var _u$speakerMaybe$speak, _u$speakerMaybe2;
      speakerMap.set(speakerName, (_u$speakerMaybe$speak = (_u$speakerMaybe2 = u.speakerMaybe) === null || _u$speakerMaybe2 === void 0 ? void 0 : _u$speakerMaybe2.speakerTrackId) !== null && _u$speakerMaybe$speak !== void 0 ? _u$speakerMaybe$speak : index);
    }
    return {
      id: String(u.id),
      speakerName,
      startTimeSeconds: parseDuration(u.start),
      endTimeSeconds: parseDuration(u.end),
      text: u.text
    };
  });
  const totalDuration = utterances.reduce((sum, u) => sum + (u.endTimeSeconds - u.startTimeSeconds), 0);
  const speakerDurations = new Map();
  for (const u of utterances) {
    var _speakerDurations$get;
    const dur = u.endTimeSeconds - u.startTimeSeconds;
    speakerDurations.set(u.speakerName, ((_speakerDurations$get = speakerDurations.get(u.speakerName)) !== null && _speakerDurations$get !== void 0 ? _speakerDurations$get : 0) + dur);
  }
  const participants = Array.from(speakerMap.entries()).map(([name, trackId]) => {
    var _speakerDurations$get2;
    return {
      name,
      speakerTrackId: trackId,
      talkTimePercentage: totalDuration > 0 ? ((_speakerDurations$get2 = speakerDurations.get(name)) !== null && _speakerDurations$get2 !== void 0 ? _speakerDurations$get2 : 0) / totalDuration * 100 : 0
    };
  });
  return {
    utterances,
    participants
  };
}
export function adaptSummary(data) {
  var _data$summary;
  return (_data$summary = data.summary) !== null && _data$summary !== void 0 ? _data$summary : undefined;
}
export function adaptNotes(data) {
  if (!data.notes) {
    return undefined;
  }
  return {
    message: data.notes
  };
}